import {
  organizationProfileCurrenTrialSelector,
  selectIsLoadingOrganizationProfile
} from "Reducers/organization/profile";
import { useAppSelector } from "Store/hooks";

export const useTrialprojects = (organizationId: string) => {
  const trial = useAppSelector(state =>
    organizationProfileCurrenTrialSelector(state, { organizationId })
  );
  const isLoading = useAppSelector(state =>
    selectIsLoadingOrganizationProfile(state, organizationId)
  );

  return {
    isLoading,
    isActive: trial?.active
  };
};
